import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _Skeleton;
import { lazy, Suspense } from 'react';
import { Skeleton } from '@crehana/ui';
import { useAddResourceBundleToNotificationsComponentTranslations } from "./hooks/useMainMenuNotificationsTranslations";
import { jsx as _jsx } from "react/jsx-runtime";
var NotificationsIconButton = /*#__PURE__*/lazy(function () {
  return import(/* webpackChunkName: "main-menu-notifications-menu" */"./Notifications");
});

/**
 * This component is not implemented directly in the CrossPlatformHeader (topbar) component.
 * Instead, it's exported to be used by the consumer. He will decide what components should render the right-side of the top bar.
 * For that, you can use the prop `renderRightSideComponents` in the `CrossPlatformHeader` component.
 */

export var LazyNotificationsIconButton = function LazyNotificationsIconButton(props) {
  // maybe because of the lazy loading, we need to add the bundle translations here and not in the Notifications component
  useAddResourceBundleToNotificationsComponentTranslations();
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: _Skeleton || (_Skeleton = /*#__PURE__*/_jsx(Skeleton, {
      className: "w-32 h-32 ml-8 rounded-full"
      // we don't have a dark theme support for the notifications
      ,
      isDark: false
    })),
    children: /*#__PURE__*/_jsx(NotificationsIconButton, _objectSpread({}, props))
  });
};